// @flow
import React, { Component } from 'react';

import DropdownMultiInput from 'components/fragments/input/DropdownMultiInput';
import type { JobFilterType, JobFiltersType, JobFiltersSearchType } from 'types/JobFilter';

type Props = {
  jobFilters: JobFiltersType,
  onFilterChange: (filters: JobFiltersSearchType) => void,
  initialFilters: JobFiltersSearchType | null,
};

type State = JobFiltersSearchType & {
  search: string,
}

class JobFilter extends Component<Props, State> {
  state = {
    domaine_emploi: [],
    region: [],
    type_contrat: [],
    search: '',
  };

  getTitleName = () => ({
    typesContrats: 'Type de contrat',
    domaines: 'Domaines',
    regions: 'Régions',
  });

  componentDidMount() {
    const { initialFilters } = this.props;

    if (initialFilters) {
      this.setState((prevState: State) => ({
        ...prevState,
        ...initialFilters,
      }));
    }

    document.addEventListener("keydown", this._handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyDown);
  }

  _convertToOptions = (jobFilter: Array<JobFilterType>): Array<Object> => {
    return jobFilter.map((filterjob) => ({ label: filterjob.name, value: filterjob.id }));
  }

  _convertToMultiOptions = (jobFilters: Object) => {
    const titles = Object.keys(jobFilters);
    const titlesName = this.getTitleName();

    return titles.reduce((result, title) => {
      result.push({ label: titlesName[title] });

      const filters = jobFilters[title].map((jobFilter) => ({
        label: jobFilter.name,
        value: jobFilter.id,
      }));

      return [
        ...result,
        ...filters,
      ];
    }, []);
  }

  _handleKeyDown = (event: KeyboardEvent) => {
    const { onFilterChange } = this.props;

    switch(event.keyCode) {
      // Enter button : 13
      case 13:
        event.preventDefault();
        onFilterChange(this.state);
        break;
      default:
        break;
    }
  }

  _onMultiInputChange = (value: string) => {
    const { jobFilters: { domaines } } = this.props;
    const isDomaine = domaines.filter((filterJob) => filterJob.id === value).length > 0;
    const type = isDomaine ? 'domaine_emploi' : 'type_contrat';

    return this._onInputChange(type, value);
  }

  _onInputChange = (jobFilter: string, value: string) => {
    const { onFilterChange } = this.props;
    this.setState((prevState: State) => {
      let newState = [];
      const jobs = prevState[jobFilter];

      if (jobs.includes(value)) {
        newState = jobs.filter(job => job !== value);
      } else {
        newState = [...jobs, value];
      }

      return {
        ...prevState,
        [jobFilter]: newState,
      };
    }, () => onFilterChange(this.state));
  }

  onSearch = (event: SyntheticInputEvent<EventTarget>) => {
    const { value } = event.target;
    const { onFilterChange } = this.props;

    this.setState({ search: value }, () => {
      onFilterChange(this.state);
    });
  }

  render() {
    const { jobFilters: { domaines, regions, typesContrats } } = this.props;
    const {
      search,
      domaine_emploi: domainesState,
      region: regionsState,
      type_contrat: typesContratsState ,
    } = this.state;

    const {
      _convertToOptions,
      _convertToMultiOptions,
      _onInputChange,
      _onMultiInputChange,
      onSearch,
    } = this;

    return (
      <div className="header-filter header-filter--team header-filter--teamWfilter mt-2">
        <div className="row">
          <div className="col col-lg-8on9">
            <div className="header-filter__left">
              <DropdownMultiInput
                label="Régions"
                id="regions"
                options={_convertToOptions(regions)}
                inputChanged={(value) => _onInputChange('region', value)}
                selected={regionsState}
                className={'dropdown dropdown--noBorder'}
                />
              <div className="multi-dropdown">
                <div className="multi-dropdown__desktop">
                  <DropdownMultiInput
                    label="Type de contrat"
                    id="typesContrats"
                    options={_convertToOptions(typesContrats)}
                    inputChanged={(value) => _onInputChange('type_contrat', value)}
                    selected={typesContratsState}
                    className={'dropdown dropdown--noBorder dropdown--checkbox'}
                    />
                  <DropdownMultiInput
                    label="Domaines"
                    id="Domaines"
                    options={_convertToOptions(domaines)}
                    inputChanged={(value) => _onInputChange('domaine_emploi', value)}
                    selected={domainesState}
                    className={'dropdown dropdown--noBorder dropdown--checkbox'}
                    />
                </div>
                <div className="multi-dropdown__mobile">
                  <DropdownMultiInput
                    label="Autres filtres"
                    id="otherFilter"
                    options={_convertToMultiOptions({ typesContrats, domaines })}
                    inputChanged={(value) => _onMultiInputChange(value)}
                    selected={[...typesContratsState, ...domainesState]}
                    className={'dropdown dropdown--noBorder'}
                    />
                </div>
              </div>
            </div>
            <div className="header-filter__right">
              <form autoComplete="off">
                <div className="input input--dropdown" data-overlay={false}>
                  <input
                    type="search"
                    onChange={onSearch}
                    id="oi8234"
                    value={search}
                    placeholder="Saisir l'intitulé d'une offre"
                    autoComplete="off" />
                  <label htmlFor="oi8234">{`Saisir l'intitulé d'une offre`}</label>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default JobFilter;
